// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__N-SF3","visible":"style_visible__Y1Jep","panel":"style_panel__Q+IWc","controls":"style_controls__7wsev","laptop":"style_laptop__GHYiw"};